import {
    Editable,
    EditableInput,
    EditableTextarea,
    EditablePreview,
    useColorModeValue
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

const EditableTitle = ({
    size,
    title,
    onSubmit,
    ml = '',
    focusInput = false,
    color = ''
}) => {
    const weight = {
        sm: '600',
        md: '600',
        lg: '700',
        category: '600',
        workspace: '600',
        workspaceModal: '700',
        groupTitle: '700'
    };
    const fontS = {
        sm: '13px',
        md: '18px',
        lg: '18px',
        category: '16px',
        workspace: '16px',
        workspaceModal: '24px',
        groupTitle: '18px'
    };

    const hoverButton = useColorModeValue('gray.100', '#32363A');
    const titleColor = useColorModeValue('#1A202C', '#FFF');

    const [innerTitle, setInnerT] = useState(title);
    const [isUntitled, setIsUntitled] = useState(
        title === '' || title === 'Untitled'
    );

    useEffect(() => {
        setInnerT(title);
        setIsUntitled(title === '' || title === 'Untitled');
    }, [title]);

    const handleChange = (value) => {
        const maxVal = value.slice(0, 24);
        setInnerT(maxVal);
        setIsUntitled(maxVal === '' || maxVal === 'Untitled');
    };
    const onSubmitInner = () => {
        onSubmit(innerTitle);
    };
    const onCancel = () => {
        setInnerT(title);
    };

    return (
        <Editable
            py="0px"
            ml={ml}
            //defaultValue={title}
            value={innerTitle}
            onChange={handleChange}
            onSubmit={onSubmitInner}
            placeholder={'Untitled'}
            fontWeight={weight[size]}
            onCancel={onCancel}
            fontSize={fontS[size]}
            textOverflow={'ellipsis'}
            wordBreak={'break-all'}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            whiteSpace={'nowrap'}
            color={
                color
                    ? color
                    : isUntitled
                    ? 'emptyStateText'
                    : 'var(--chakra-colors-text)'
            }
            startWithEditView={focusInput}
        >
            <EditablePreview
                opacity={isUntitled ? 0.6 : 1}
                py="0px"
                /* _hover={{
                    bg: hoverButton,
                    color: isUntitled ? 'gray.400' : titleColor
                }} */
            />
            <EditableInput
                rounded={size === 'sm' ? '4px' : '6px'}
                py="0px" /* _focus={{ boxShadow: noOutline ? 'none' : null }} */
                /* sx={{
                    '&::selection': {
                        bg: 'rgba(85, 166, 254, 0.5)'
                    }
                }} */
            />
        </Editable>
    );
};

export default EditableTitle;
